module.exports = __webpack_public_path__ + "img/observa4-draw.1b121717.jpg";